export default __webpack_public_path__ + "678e5cce500cb03579c5f9b08877549c.png";